import React from 'react';

import facebook from '../../static/images/facebook.svg'
import instagram from '../../static/images/instagram.svg'
import youtube from '../../static/images/youtube.svg'

const Footer = () => {
    return (
        <footer className="row text-white py-4 py-md-5 w-100 mx-0">
            <div style={{ opacity: '75%' }} className='col-12 col-md-4 text-white  m-0 d-flex justify-content-center align-items-center'>
                <p>&#169;martinpetrovicky 2022</p>
            </div>
            <div className='col-12 col-md-4 text-center  m-0 d-flex flex-column justify-content-center align-items-center my-3 my-md-0'>
                <p style={{fontSize: 24}}>Martin Petrovický</p>

            </div>
            <div style={{ opacity: '75%' }} className='col-12 col-md-4 m-0 d-flex justify-content-center align-items-center'>
                <a href='https://www.facebook.com/Martin-Petrovick%C3%BD-Photo-Video-112472620127868'><img alt="facebook icon" style={{ cursor: 'pointer', width:40 }} src={facebook} /></a>
                <a href='https://www.instagram.com/martin___cz/' ><img className='me-2' alt="instagram icon" style={{ cursor: 'pointer', width:40 }} src={instagram} /></a>
                <a href='https://www.youtube.com/channel/UCDofCthAFw0xmT6FJ3mn2Kw' ><img alt="youtube icon" style={{ cursor: 'pointer', width:40 }} src={youtube} /></a>
            </div>

        </footer>
    )
}

export default Footer